<template>
  <div class="carrier-message">
    <h1>
      Are you looking for something else?
      <a href="mailto:ltl@goglt.com" target="_blank">Contact us now!</a>
    </h1>
  </div>
</template>

<script>
export default {
  name: "CarrierMessage",
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
.carrier-message {
  text-align: center;
  color: $color-primary-company;
  padding-top: 20px;
  h1 {
    padding-top: 20px;
    font-size: 20px;
    font-family: $font-family-portal;
  }
  a {
    color: $color-primary-company;
    text-decoration: underline;
  }
}
@media (max-width: 800px) {
  .carrier-message {
    padding-top: 80px;
  }
}
</style>
